import React from 'react';
import { Sparkles, Mic, MessageSquare, Radio } from 'lucide-react';
import { useApp } from '../contexts/AppContext';

// N.E.O Command Center — halaman pusat komunikasi N.E.O (orchestrator AI).
// Status: SEGERA / COMING SOON. Placeholder dengan preview kapabilitas.
const NeoCommand = () => {
  const { lang } = useApp();
  const id = lang === 'id';

  const features = [
    {
      icon: MessageSquare,
      title: id ? 'Komando Bahasa Natural' : 'Natural Language Command',
      desc: id
        ? 'Perintahkan seluruh sistem cukup dengan mengetik atau berbicara — N.E.O yang mengatur agent-agent AI.'
        : 'Command the entire system by typing or speaking — N.E.O orchestrates the AI agents.',
    },
    {
      icon: Radio,
      title: id ? 'Orkestra Multi-Agent' : 'Multi-Agent Orchestration',
      desc: id
        ? 'Vision, Identity, OSINT, Plat, dan Threat Scoring bekerja paralel di bawah satu konduktor.'
        : 'Vision, Identity, OSINT, Plate, and Threat Scoring run in parallel under one conductor.',
    },
    {
      icon: Mic,
      title: id ? 'Briefing Suara Real-Time' : 'Real-Time Voice Briefing',
      desc: id
        ? 'N.E.O melaporkan situasi kota, ancaman aktif, dan rekomendasi tindakan secara lisan.'
        : 'N.E.O reports city situation, active threats, and recommended actions by voice.',
    },
  ];

  return (
    <div className="h-full overflow-y-auto c-scroll flex items-center justify-center p-6"
      style={{ background: 'var(--color-bg)' }}>
      <div className="w-full max-w-2xl text-center">
        {/* Orb */}
        <div className="relative mx-auto mb-6 flex items-center justify-center"
          style={{ width: 96, height: 96 }}>
          <div className="absolute inset-0 rounded-full animate-ping"
            style={{ background: 'rgba(0,212,255,0.12)' }} />
          <div className="relative flex items-center justify-center rounded-full"
            style={{
              width: 88, height: 88,
              background: 'radial-gradient(circle at 35% 30%, rgba(0,212,255,0.35), rgba(124,77,255,0.15))',
              border: '1px solid rgba(0,212,255,0.4)',
              boxShadow: '0 0 40px rgba(0,212,255,0.25)',
            }}>
            <Sparkles size={36} color="var(--color-cyan)" />
          </div>
        </div>

        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-4"
          style={{ background: 'rgba(255,214,10,0.1)', border: '1px solid rgba(255,214,10,0.3)' }}>
          <span className="w-1.5 h-1.5 rounded-full animate-blink" style={{ background: '#ffd60a' }} />
          <span className="text-[9px] font-black font-mono tracking-widest" style={{ color: '#ffd60a' }}>
            {id ? 'SEGERA HADIR' : 'COMING SOON'}
          </span>
        </div>

        <h1 className="text-2xl font-black mb-2" style={{ color: 'var(--text-hi)', fontFamily: 'IBM Plex Mono' }}>
          N.E.O Command Center
        </h1>
        <p className="text-sm mb-1" style={{ color: 'var(--text-dim)' }}>
          {id ? 'Neural Entity Orchestration' : 'Neural Entity Orchestration'}
        </p>
        <p className="text-xs max-w-md mx-auto mb-8" style={{ color: 'var(--text-mute)' }}>
          {id
            ? 'Otak komando HORUS — seperti JARVIS, tapi nyata dan buatan anak bangsa. Satu pusat untuk mengendalikan seluruh sistem dengan bahasa natural.'
            : 'The command brain of HORUS — like JARVIS, but real. One hub to control the entire system in natural language.'}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-left">
          {features.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="rounded-xl p-4"
              style={{ background: 'var(--color-card)', border: '1px solid var(--border-dim)' }}>
              <Icon size={18} color="var(--color-cyan)" />
              <p className="text-[11px] font-bold mt-2.5 mb-1" style={{ color: 'var(--text-hi)' }}>{title}</p>
              <p className="text-[9.5px] leading-relaxed" style={{ color: 'var(--text-mute)' }}>{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NeoCommand;
